import { ContentTag } from "scrivito"
import { ProductCategoryObj } from "scrivito/Objs/ProductCategory/ProductCategoryObjClass"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { useScrollController } from "features/scroll-management/model/useScrollController"
import { ProductCategoryDetails } from "widgets/product-category-details/ProductCategoryDetails"

import { useProductCategoryPageModel } from "./model/useProductCategoryPageModel"
import "./styles/_product-category-page.scss"

interface ProductCategoryPageProps {
  page: ProductCategoryObj
}

export function ProductCategoryPage({ page }: ProductCategoryPageProps) {
  useScrollController()
  useScrivitoPage()

  const {
    defaultValues,
    category,
    products,
    productGroupOptions,
    filter,
    onChange
  } = useProductCategoryPageModel({ page })

  return (
    <div id="product-category-page" className="product-category-page">
      <ContentTag content={page} attribute="breadcrumbWidget" />
      <ProductCategoryDetails
        category={category}
        products={products}
        productGroupOptions={productGroupOptions}
        onFilterChange={onChange}
        filter={filter}
        defaultFilter={defaultValues}
      />
    </div>
  )
}
